export default function () {
  return {
    listings: [],
    cartId: null,
    userId: null,
    licenseId: null,
    isLoading: false,
    lastError: null,
    singleOrderItem: null,
    singleOrderMode: false,
    externalPoItems: [],
  };
}
